import React from 'react'

const RootPortalContext = React.createContext<Element | ShadowRoot | undefined>(undefined)

export const useRoot = () => {
  return React.use(RootPortalContext) ?? document.body
}

/** Control which element DS considers root */
export const RootProvider = ({
  children,
  root,
}: {
  children?: React.ReactNode
  root: Element | ShadowRoot | undefined
}) => {
  return <RootPortalContext value={root}>{children}</RootPortalContext>
}
